import axios from "axios";

function login(payload) {
  console.log("login");
  console.log(payload);
  return retrieveToken("/authenticate", payload);
}

function retrieveToken(url, payload) {
  console.log("retrieve token");
  return axios
    .post(process.env.VUE_APP_API_URL + url, payload)
    .then(handleResponse)
    .then(response => {
      console.log(response);
      const token = response.token;
      if (token) {
        localStorage.setItem("token", token);
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      }

      return response;
    });
}

function handleResponse(res) {
  const data = res.data;

  if (data.error) {
    if (res.status === 401) {
      logout();
    }

    return Promise.reject(error);
  }

  return data;
}

function logout() {
  delete axios.defaults.headers.common["Authorization"];
}

function get(url) {
  return axios.get(process.env.VUE_APP_API_URL + url).then(handleResponse);
}

function patch(url, payload) {
  return axios.patch(process.env.VUE_APP_API_URL + url, payload);
}

function put(url, payload) {
  return axios.put(process.env.VUE_APP_API_URL + url, payload, {
    headers: { "expecting-response": "full" }
  });
}

function remove(url) {
  return axios.delete(process.env.VUE_APP_API_URL + url);
}

export const service = {
  login,
  get,
  logout,
  patch,
  put,
  remove
};
